var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerpointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 1.5V4.83333C8.66797 5.05435 8.75577 5.26631 8.91205 5.42259C9.06833 5.57887 9.28029 5.66667 9.5013 5.66667H12.8346M8.66797 1.5H2.83464C2.39261 1.5 1.96868 1.67559 1.65612 1.98816C1.34356 2.30072 1.16797 2.72464 1.16797 3.16667V9M8.66797 1.5L12.8346 5.66667M12.8346 5.66667V9M1.16797 14H2.41797C2.74949 14 3.06743 13.8683 3.30185 13.6339C3.53627 13.3995 3.66797 13.0815 3.66797 12.75C3.66797 12.4185 3.53627 12.1005 3.30185 11.8661C3.06743 11.6317 2.74949 11.5 2.41797 11.5H1.16797V16.5M6.16797 14H7.41797C7.74949 14 8.06743 13.8683 8.30185 13.6339C8.53627 13.3995 8.66797 13.0815 8.66797 12.75C8.66797 12.4185 8.53627 12.1005 8.30185 11.8661C8.06743 11.6317 7.74949 11.5 7.41797 11.5H6.16797V16.5M10.7513 11.5H13.2513M12.0013 11.5V16.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpointIcon);
export default __webpack_public_path__ + "static/media/powerpoint-icon.af7ee6bf7e638b205a77ade086687287.svg";
export { ForwardRef as ReactComponent };